const resources = {
  "en": {
    "timezones": {
      "newYork": "New York",
      "kyiv": "Kyiv"
    }
  },
  "uk": {
    "timezones": {
      "newYork": "Нью-Йорк",
      "kyiv": "Київ"
    }
  }
};

export default resources;
